/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: `${(window as any).app.env.B2C_CLIENT_ID}`, // "27bd5feb-2a85-42da-89ae-911e4c492619",
    authority: `${(window as any).app.env.B2C_AUTHORITY}`, // "https://ceventasb2c.b2clogin.com/ceventasb2c.onmicrosoft.com/B2C_1_signin",
    knownAuthorities: [`${(window as any).app.env.B2C_KNOWN_AUTHORITY}`], //  [ "ceventasb2c.b2clogin.com" ], // You must identify your tenant's domain as a known authority.
    redirectUri: `${window.location.protocol}//${window.location.host}`, //"https://localhost:44337" //"http://localhost:6420"
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "localStorage", //"sessionStorage", // This configures where your cache will be stored, see: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/caching.md
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      //logLevel: LogLevel.Verbose,
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            //console.error(`ERR: ${message}`);
            return;
          case LogLevel.Info:
            //console.info(`INF: ${message}`);
            return;
          case LogLevel.Verbose:
            //console.debug(`VER: ${message}`);
            return;
          case LogLevel.Warning:
            //console.warn(`WAR: ${message}`);
            return;
        }
      },
      piiLoggingEnabled: false
    }
  }
};

export const apiConfig = {
  b2cScopes: [`${(window as any).app.env.B2C_SCOPE}`] // ["https://ceventasb2c.onmicrosoft.com/clarityapp-api/clarityapp.read"], //["https://fabrikamb2c.onmicrosoft.com/helloapi/demo.read"],
  //webApi: "https://localhost:44337", //"https://fabrikamb2chello.azurewebsites.net/hello"
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [...apiConfig.b2cScopes]
};

export const tokenRequest = {
  scopes: [...apiConfig.b2cScopes], // e.g. ["https://fabrikamb2c.onmicrosoft.com/helloapi/demo.read"]
  forceRefresh: false // Set this to "true" to skip a cached token and go to the server to get a new token
};
